export const getCurrentUserClientId = (state) => {
  const user = state?.auth?.session?.user || {};
  const rawClientId =
    user.client_id ??
    user.clientId ??
    user.client?.id ??
    user.client?.client_id;
  const clientId = Number(rawClientId);
  return Number.isFinite(clientId) && clientId > 0 ? clientId : null;
};

export const getRequiredCurrentUserClientId = (state) => {
  const clientId = getCurrentUserClientId(state);
  if (!clientId) {
    throw new Error("Unable to resolve the current organization.");
  }
  return clientId;
};
